
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { PLACE_ENUM, FULL_SIZE_COLUMN } from '@utils/constants';
import { Spin, Card, Row, Col, Button, Table } from 'antd';
import FileSaver from 'file-saver';
import domtoimage from 'dom-to-image';
import { formatNumber, searchText, initProductMeta, groupBy, formatDate, removeAccent } from '@utils/helper';
import './style.less';

const ITEM_PER_PAGE = 10;

function FacebookPost(props) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const { isLoading, mutate: getPostList } = useMutation(() => {
    return request.get('v1/facebook-post');
  },
    {
      onSuccess: (response) => {
        const {count, rows} = response.data;
        setData(rows);
        setTotal(count);
      },
    });
  useEffect(() => {
    getPostList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderFacebookPost = (item, ind) => {
      // const sku = p.code.toLowerCase();
      // const item = productList.find(x => x.pSku === sku);
      // if (!item) return '';
      const cover = (
        <p>
          <img alt={item.productName} src={item.image} />
        </p>
      );
      return (
        <Col sm={6} style={{ marginBottom: 16 }} key={item.pSku}>
          <Card className='productItem' hoverable cover={cover}>
            <div style={{ height: 42 }}>{item.productName} - {item.sku}</div>
            <div>
              {item.content}
            </div>
          </Card>
        </Col>
      )
    }

  return (
    <Spin spinning={isLoading}>
      <Row gutter={16}>
        <Col sm={12}>
          <h2>Facebook Post</h2>
        </Col>
        <Col sm={6}>
        </Col>
      </Row>
      <Row gutter={16}>
        {data.map(renderFacebookPost)}
      </Row>
    </Spin>
  )
}

FacebookPost.propTypes = {
  dataSource: PropTypes.array,
  categoryList: PropTypes.array,
  loading: PropTypes.bool,
};

FacebookPost.defaultProps = {
  dataSource: [],
  categoryList: [],
  loading: false,
};

export default FacebookPost;